import { Link } from 'react-router-dom'
import Box from '@mui/material/Box'
import BrandLogo from '@/assets/brand_logo.svg'
import DomainLogo from '@/assets/domain_logo.svg'
import NetsolLogo from '@/assets/netsol-bw-logo.svg'
import { getBrand } from '@/helpers/brandHelper.js'

const HeaderLogo = ({ ...props }) => {
  const brand = getBrand()
  const BRAND_LOGO = {
    webdotcom: BrandLogo,
    domaincom: DomainLogo,
    networksolutions: NetsolLogo
  }

  return (
    <Box {...props} className='flex gap-5 w-full select-none'>
      {brand === 'networksolutions'
      ? <Link to='https://www.networksolutions.com/my-account/home'><img width={brand === "networksolutions"? 130: 38} src={BRAND_LOGO[brand] || BrandLogo} /></Link>
      : <img width={brand === "networksolutions"? 80: 38} src={BRAND_LOGO[brand] || BrandLogo} />}
    </Box>
  )
}

export default HeaderLogo
